// Dashboard Constants and Configuration
import { scopedDashboardKey } from './dashboardStorageScope';

// Legacy widget ID mapping for backward compatibility
export const LEGACY_WIDGET_MAPPING: Record<string, string> = {
  'project-health': 'health-status',
  'kpis': 'metrics',
  'milestones': 'timeline',
  'issues-solutions': 'opportunities',
  'upcoming-milestones': 'timeline'
};

// LocalStorage key generators
export const getDashboardLayoutsKey = (viewMode: string) =>
  scopedDashboardKey(`dashboard-layouts-${viewMode}`);
export const getDashboardCurrentLayoutKey = (viewMode: string) =>
  scopedDashboardKey(`dashboard-current-layout-${viewMode}`);

// Grid configuration constants
export const GRID_SIZE = 20; // Standard grid size for stability
export const ROW_HEIGHT = 60; // Standard row height for proper widget sizing
export const DRAG_THRESHOLD = 5;

export const GRID_CONFIG = {
  GRID_SIZE,
  ROW_HEIGHT,
  DRAG_THRESHOLD,
  MAX_ROWS: 100, // Extended canvas for freeform placement
  BREAKPOINTS: {
    lg: 1800,
    md: 1200,
    sm: 768,
    xs: 480,
    xxs: 0
  },
  COLS: {
    lg: 24,
    md: 18,
    sm: 12,
    xs: 8,
    xxs: 6
  }
} as const;
